export enum WorkflowExecutionStepInterventionStatus {
  NEEDED = 1,
  COMPLETED = 2,
}
